import { __spreadArray, __assign } from 'tslib';
import { v4 } from 'uuid';

var version$1 = "0.1.13";

/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
    if (!data) {
        return data;
    }
    var enc = base64encode(data);
    return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
    // discuss at: http://phpjs.org/functions/base64_encode/
    // original by: Tyler Akins (http://rumkin.com)
    // improved by: Bayron Guevara
    // improved by: Thunder.m
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: Rafał Kukawski (http://kukawski.pl)
    // bugfixed by: Pellentesque Malesuada
    // example 1: base64_encode('Kevin van Zonneveld');
    // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
    // example 2: base64_encode('a');
    // returns 2: 'YQ=='
    // example 3: base64_encode('✓ à la mode');
    // returns 3: '4pyTIMOgIGxhIG1vZGU='
    var o1;
    var o2;
    var o3;
    var h1;
    var h2;
    var h3;
    var h4;
    var bits;
    var i = 0;
    var ac = 0;
    var tmp_arr = [];
    if (!data) {
        return data;
    }
    data = unescape(encodeURIComponent(data));
    do {
        // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);
    var enc = tmp_arr.join('');
    var r = data.length % 3;
    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}

var label = 'MB Tracker: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
    LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
    LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
    LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
    LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var LOG = logger();
function logger(logLevel) {
    if (logLevel === void 0) { logLevel = LOG_LEVEL.warn; }
    function setLogLevel(level) {
        if (LOG_LEVEL[level]) {
            logLevel = level;
        }
        else {
            logLevel = LOG_LEVEL.warn;
        }
    }
    /**
     * Log errors, with or without error object
     */
    function error(message, error) {
        var extraParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraParams[_i - 2] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
            var logMsg = label + message + '\n';
            if (error) {
                console.error.apply(console, __spreadArray([logMsg + '\n', error], extraParams));
            }
            else {
                console.error.apply(console, __spreadArray([logMsg], extraParams));
            }
        }
    }
    /**
     * Log warnings, with or without error object
     */
    function warn(message, error) {
        var extraParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraParams[_i - 2] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
            var logMsg = label + message;
            if (error) {
                console.warn.apply(console, __spreadArray([logMsg + '\n', error], extraParams));
            }
            else {
                console.warn.apply(console, __spreadArray([logMsg], extraParams));
            }
        }
    }
    /**
     * Log debug messages
     */
    function debug(message) {
        var extraParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraParams[_i - 1] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
            console.debug.apply(console, __spreadArray([label + message], extraParams));
        }
    }
    /**
     * Log info messages
     */
    function info(message) {
        var extraParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraParams[_i - 1] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
            console.info.apply(console, __spreadArray([label + message], extraParams));
        }
    }
    return { setLogLevel: setLogLevel, warn: warn, error: error, debug: debug, info: info };
}

function payloadBuilder() {
    var dict = {};
    var allJson = [];
    var jsonForProcessing = [];
    var processor;
    var add = function (key, value) {
        if (value != null && value !== '') {
            // null also checks undefined
            dict[key] = value;
        }
    };
    var addDict = function (dict) {
        for (var key in dict) {
            if (Object.prototype.hasOwnProperty.call(dict, key)) {
                add(key, dict[key]);
            }
        }
    };
    var addJson = function (keyIfEncoded, keyIfNotEncoded, json) {
        if (json && isNonEmptyJson(json)) {
            var jsonWithKeys = { keyIfEncoded: keyIfEncoded, keyIfNotEncoded: keyIfNotEncoded, json: json };
            jsonForProcessing.push(jsonWithKeys);
            allJson.push(jsonWithKeys);
        }
    };
    var addJsonProps = function (keyIfNotEncoded, json) {
        // If key was found in dict, use it.
        if (dict[keyIfNotEncoded] && typeof dict[keyIfNotEncoded] === 'object') {
            dict[keyIfNotEncoded] = __assign(__assign({}, dict[keyIfNotEncoded]), json);
            return;
        }
        // If already exists key the but the value was not an object, do nothing.
        if (dict[keyIfNotEncoded] && typeof dict[keyIfNotEncoded] === 'object') {
            LOG.error("The key '" + keyIfNotEncoded + "' found in dictionary but was not an object");
            return;
        }
        var currentJsonForProcessing = jsonForProcessing.find(function (j) { return j.keyIfNotEncoded === keyIfNotEncoded; });
        var currentJson = allJson.find(function (j) { return j.keyIfNotEncoded === keyIfNotEncoded; });
        if (!currentJsonForProcessing || !currentJson) {
            return addJson(keyIfNotEncoded, keyIfNotEncoded, json);
        }
        currentJsonForProcessing.json = __assign(__assign({}, currentJsonForProcessing.json), json);
        currentJson.json = __assign(__assign({}, currentJson.json), json);
    };
    return {
        add: add,
        addDict: addDict,
        addJson: addJson,
        addJsonProps: addJsonProps,
        getPayload: function () { return dict; },
        getJson: function () { return allJson; },
        withJsonProcessor: function (jsonProcessor) {
            processor = jsonProcessor;
        },
        build: function () {
            processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing);
            return dict;
        }
    };
}
/**
 * A helper to build a Mailbiz Tracker request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
    return function (payloadBuilder, jsonForProcessing) {
        for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
            var json = jsonForProcessing_1[_i];
            var str = JSON.stringify(json.json);
            if (encodeBase64) {
                payloadBuilder.add(json.keyIfEncoded, base64urlencode(str));
            }
            else {
                // only 'data' should be a string
                payloadBuilder.add(json.keyIfNotEncoded, json.keyIfNotEncoded === 'data' ? str : json.json);
            }
        }
        jsonForProcessing.length = 0;
    };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
    if (!isJson(property)) {
        return false;
    }
    for (var key in property) {
        if (Object.prototype.hasOwnProperty.call(property, key)) {
            return true;
        }
    }
    return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
    return (typeof property !== 'undefined' &&
        property !== null &&
        (property.constructor === {}.constructor || property.constructor === [].constructor));
}

/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
    if (timestamp == null) {
        return { type: 'created_at', value: new Date().toISOString() };
    }
    else if (typeof timestamp === 'string') {
        return { type: 'created_at', value: timestamp };
    }
    else if (timestamp.type === 'true_timestamp') {
        // We can return timestamp here, but this is safer fallback
        return { type: 'true_timestamp', value: timestamp.value };
    }
    else {
        return { type: 'created_at', value: timestamp.value || new Date().toISOString() };
    }
}
function getTimeZone() {
    var offset = new Date().getTimezoneOffset();
    var o = Math.abs(offset);
    return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2);
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
    if (configuration === void 0) { configuration = {}; }
    function newCore(base64, corePlugins, callback) {
        var encodeBase64 = base64;
        var payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
        /**
         * Gets called by every trackXXX method
         * Adds context and payloadPairs name-value pairs to the payload
         * Applies the callback to the built payload
         *
         * @param pb - Payload
         * @param context - Custom contexts relating to the event
         * @param timestamp - Timestamp of the event
         * @returns Payload after the callback is applied
         */
        function track(pb, _context, timestamp) {
            var _a;
            pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
            pb.add('hash', v4());
            pb.addDict(payloadPairs);
            var tstamp = getTimestamp(timestamp);
            pb.addJson('timings', 'timings', (_a = {},
                _a[tstamp.type] = tstamp.value.toString(),
                _a.timezone = getTimeZone(),
                _a));
            corePlugins.forEach(function (plugin) {
                try {
                    if (plugin.beforeTrack) {
                        plugin.beforeTrack(pb);
                    }
                }
                catch (ex) {
                    LOG.error('Plugin beforeTrack', ex);
                }
            });
            if (typeof callback === 'function') {
                callback(pb);
            }
            var finalPayload = pb.build();
            corePlugins.forEach(function (plugin) {
                try {
                    if (plugin.afterTrack) {
                        plugin.afterTrack(finalPayload);
                    }
                }
                catch (ex) {
                    LOG.error('Plugin afterTrack', ex);
                }
            });
            return finalPayload;
        }
        /**
         * Set a persistent key-value pair to be added to every payload
         *
         * @param key - Field name
         * @param value - Field value
         */
        function addPayloadPair(key, value) {
            payloadPairs[key] = value;
        }
        /**
         * Set a persistent key-value pair to be added on json property to every payload
         *
         * @param key - Field name
         * @param value - Field value
         */
        function addJsonPayloadPair(jsonKey) {
            return function (key, value) {
                payloadPairs[jsonKey] = payloadPairs[jsonKey] || {};
                payloadPairs[jsonKey][key] = value;
            };
        }
        /**
         * Set a persistent key-value pair to be added on context property to every payload
         *
         * @param key - Field name
         * @param value - Field value
         */
        function addPayloadContextPair(key, value) {
            return addJsonPayloadPair('context')(key, value);
        }
        /**
         * Set a persistent key-value pair to be added on identity property to every payload
         *
         * @param key - Field name
         * @param value - Field value
         */
        function addPayloadIdentityPair(key, value) {
            return addJsonPayloadPair('identity')(key, value);
        }
        var core = {
            track: track,
            addPayloadPair: addPayloadPair,
            addPayloadContextPair: addPayloadContextPair,
            addPayloadIdentityPair: addPayloadIdentityPair,
            getBase64Encoding: function () {
                return encodeBase64;
            },
            setBase64Encoding: function (encode) {
                encodeBase64 = encode;
            },
            addPayloadDict: function (dict) {
                for (var key in dict) {
                    if (Object.prototype.hasOwnProperty.call(dict, key)) {
                        payloadPairs[key] = dict[key];
                    }
                }
            },
            resetPayloadPairs: function (dict) {
                payloadPairs = isJson(dict) ? dict : {};
            },
            setTrackerVersion: function (version) {
                addPayloadContextPair('js_version', version);
            },
            setTrackerNamespace: function (_name) {
                // addPayloadPair('tna', name);
            },
            setAppId: function (appId) {
                addPayloadPair('app_id', appId);
            },
            setPlatform: function (value) {
                addPayloadContextPair('platform', value);
            },
            setUserId: function (userId) {
                addPayloadIdentityPair('user_id', userId);
            },
            setScreenResolution: function (width, height) {
                addPayloadContextPair('screen', width + 'x' + height);
            },
            setViewport: function (width, height) {
                addPayloadContextPair('view_size', width + 'x' + height);
            },
            setColorDepth: function (_depth) {
                // addPayloadPair('cd', depth);
            },
            setTimezone: function (timezone) {
                addJsonPayloadPair('timings')('timezone', timezone);
            },
            setLang: function (lang) {
                addPayloadContextPair('language', lang);
            },
            setIpAddress: function (ip) {
                addPayloadContextPair('ip', ip);
            },
            setUseragent: function (useragent) {
                addPayloadContextPair('ua', useragent);
            }
        };
        return core;
    }
    var base64 = configuration.base64, corePlugins = configuration.corePlugins, callback = configuration.callback;
    var plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [];
    var partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : false, plugins, callback);
    var core = __assign({}, partialCore);
    plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
        var _a, _b;
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
    });
    return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
    var data = event.event.data, eventName = event.eventName;
    var pb = payloadBuilder();
    pb.add('event', eventName);
    pb.addJson('data', 'data', __assign({}, data));
    return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
    var pageUrl = event.pageUrl, pageTitle = event.pageTitle, referrer = event.referrer, keywords = event.keywords;
    var pb = payloadBuilder();
    pb.add('event', 'page.view');
    var urlPaths = (pageUrl !== null && pageUrl !== void 0 ? pageUrl : '').split('//').join('').split('/');
    var urlPath = urlPaths.length > 1 ? urlPaths[urlPaths.length - 1].split('/')[0] : '';
    pb.addJsonProps('data', {
        page: {
            title: pageTitle,
            url: pageUrl,
            path: "/" + urlPath,
            referrer: referrer,
            keywords: keywords
        }
    });
    return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
    var pageUrl = event.pageUrl, pageTitle = event.pageTitle, referrer = event.referrer, minXOffset = event.minXOffset, maxXOffset = event.maxXOffset, minYOffset = event.minYOffset, maxYOffset = event.maxYOffset;
    var pb = payloadBuilder();
    pb.add('event', 'page.ping'); // 'pp' for Page Ping
    var page = {
        title: pageTitle,
        url: pageUrl,
        referrer: referrer
    };
    if (minXOffset && !isNaN(Number(minXOffset)))
        page.pp_mix = minXOffset.toString();
    if (maxXOffset && !isNaN(Number(maxXOffset)))
        page.pp_max = maxXOffset.toString();
    if (minYOffset && !isNaN(Number(minYOffset)))
        page.pp_miy = minYOffset.toString();
    if (maxYOffset && !isNaN(Number(maxYOffset)))
        page.pp_may = maxYOffset.toString();
    pb.addJsonProps('data', {
        page: page
    });
    return pb;
}
/**
 * Build a Account Sync Event
 * Fires to synchronize update user data
 *
 * @param event - Contains the user data
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildAccountSync(event) {
    var pb = payloadBuilder();
    pb.add('event', 'account.sync');
    pb.addJsonProps('data', __assign({}, removeEmptyProperties(__assign({}, event))));
    return pb;
}
/**
 * Build a Account Login Event
 * Fires when user log in
 *
 * @param event - Contains the user data
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildAccountLogin(event) {
    var pb = payloadBuilder();
    pb.add('event', 'account.login');
    pb.addJsonProps('data', __assign({}, removeEmptyProperties(__assign({}, event))));
    return pb;
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
    return buildSelfDescribingEvent({
        event: {
            data: {
                products: event.products.map(function (p) { return removeEmptyProperties(__assign({}, p)); })
            }
        },
        eventName: 'cart.add'
    });
}
/**
 * Build a Cart Sync From Cart Event
 * For sync cart data
 *
 * @param event - Contains the properties for the Cart Sync From Cart event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildCartSync(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'cart.sync'
    });
}
/**
 * Build a Cart Item Quantity Change Event
 *
 * @param eventName
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
var buildCartChangeQuantity = function (eventName) {
    return function (event) {
        return buildSelfDescribingEvent({
            event: {
                data: __assign({}, event)
            },
            eventName: eventName
        });
    };
};
/**
 * Build a Cart Item update Event
 *
 * @param event - Contains the properties for the Cart event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildCartItemUpdate(event) {
    return buildCartChangeQuantity('cart.item.update')(event);
}
/**
 * Build a Set Postal Code From Cart Event
 *
 * @param event - Contains the properties for the Cart event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildCartSetPostalCode(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'cart.setpostalcode'
    });
}
/**
 * Build a Set Coupon From Cart Event
 *
 * @param event - Contains the properties for the Cart event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildCartSetCoupon(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'cart.setcoupon'
    });
}
/**
 * Build a Set Checkout Step Event
 *
 * @param event - Contains the properties for the Checkout event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildCheckoutStep(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'checkout.step'
    });
}
/**
 * Build a Order Complete Event
 *
 * @param event - Contains the properties for the Order event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildOrderComplete(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'order.complete'
    });
}
/**
 * Build a Order Cancel Event
 *
 * @param event - Contains the properties for the Order event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildOrderCancel(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, event)
        },
        eventName: 'order.cancel'
    });
}
/**
 * Build a Product View From Product Event
 * For product view data
 *
 * @param event - Contains the properties for the Product View From Product Event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildProductView(event) {
    return buildSelfDescribingEvent({
        event: {
            data: __assign({}, removeEmptyProperties(__assign({}, event)))
        },
        eventName: 'product.view'
    });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @mailbiz/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
    var terms = event.terms, filters = event.filters, totalResults = event.totalResults, pageResults = event.pageResults;
    return buildSelfDescribingEvent({
        event: {
            data: removeEmptyProperties({ terms: terms, filters: filters, totalResults: totalResults, pageResults: pageResults })
        },
        eventName: 'site.search'
    });
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
    if (exemptFields === void 0) { exemptFields = {}; }
    var ret = {};
    for (var k in event) {
        if (exemptFields[k] || (event[k] !== null && typeof event[k] !== 'undefined')) {
            ret[k] = event[k];
        }
    }
    return ret;
}

/**
 * A library of helpful methods for Mailbiz JavaScript Trackers
 * Contains Context Generation, Event Payload Builders, and Core Plugins.
 *
 * @packageDocumentation
 */
var version = version$1;

export { LOG, LOG_LEVEL, buildAccountLogin, buildAccountSync, buildAddToCart, buildCartItemUpdate, buildCartSetCoupon, buildCartSetPostalCode, buildCartSync, buildCheckoutStep, buildOrderCancel, buildOrderComplete, buildPagePing, buildPageView, buildProductView, buildSelfDescribingEvent, buildSiteSearch, isJson, isNonEmptyJson, payloadBuilder, payloadJsonProcessor, trackerCore, version };
//# sourceMappingURL=index.module.js.map
